module.exports = __webpack_public_path__ + "static/media/boss-student-bg.37d06206.png";